import {
	ChangeEventHandler,
	FocusEventHandler,
	HTMLInputTypeAttribute,
} from "react";

interface Props {
	onChange: ChangeEventHandler<HTMLTextAreaElement>;

	name?: string;
	label?: string;
	rows?: number;
	onBlur?: FocusEventHandler;
	value?: string | number | string[] | undefined;
	disabled?: boolean;
	readOnly?: boolean;
	autoFocus?: boolean;
	isInvalid?: boolean;
	className?: string;
	placeholder?: string;
	error?: string;
}

const AppTextarea: React.FC<Props> = (props) => {
	const {
		disabled,
		name,
		readOnly,
		value,
		isInvalid,
		autoFocus,
		label,
		placeholder,
		error,
		rows,
		onChange,
		onBlur,
		className,
	} = props;

	return (
		<div className={`form-control w-full app-textarea ${className}`}>
			{label && (
				<label className="label">
					<span className="label-text">{label}</span>
				</label>
			)}

			<textarea
				className={`textarea textarea-bordered ${
					isInvalid ? "textarea-error" : ""
				}`}
				name={name}
				rows={rows}
				onChange={onChange}
				onBlur={onBlur}
				placeholder={placeholder}
				value={value}
				disabled={disabled}
				readOnly={readOnly}
				autoFocus={autoFocus}
			/>
			{isInvalid && (
				<label className="label">
					<span className="label-text-alt">{error}</span>
				</label>
			)}
		</div>
	);
};
export default AppTextarea;
